module.exports = __webpack_public_path__ + "img/itsm12.c66db4aa.png";